import { LOGOUT } from 'modules/auth/actions/logout';
import createReducer from 'shared/utils/createReducer';
import { HIDE_APPOINTMENT_INFO } from 'modules/queues/common/actions/appointmentInfo';
import {
  SET_INTERNET_SLOW,
  INTERNET_ESTABLISHED,
  ADD_SLOW_INTERNET_TOAST,
  ADD_SLOW_INTERNET_STATS,
  REMOVE_SLOW_INTERNET_TOAST,
} from 'modules/conference/actions/connectionMeter';


const defaultState = {
  isNeedToShowToast: false,
  isToastWasShown: false,
  isInternetSlow: false,
  slowInternetStats: [],
  slowInternetStartTime: null,
};

export default createReducer(defaultState, {
  [SET_INTERNET_SLOW]: (state, { payload: { internetSpeed, date } }) => ({
    ...state,
    isInternetSlow: true,
    slowInternetStartTime: date,
    slowInternetStats: [Number(internetSpeed)],
  }),

  [ADD_SLOW_INTERNET_STATS]: (state, { payload: { internetSpeed } }) => ({
    ...state,
    slowInternetStats: [...state.slowInternetStats, Number(internetSpeed)],
  }),

  [ADD_SLOW_INTERNET_TOAST]: (state) => ({
    ...state,
    isNeedToShowToast: true,
    isToastWasShown: true,
  }),

  [REMOVE_SLOW_INTERNET_TOAST]: (state) => ({
    ...state,
    isNeedToShowToast: false,
  }),

  [HIDE_APPOINTMENT_INFO]: () => defaultState,
  [INTERNET_ESTABLISHED]: () => defaultState,
  [LOGOUT.success]: () => defaultState,
  [LOGOUT.failure]: () => defaultState,
});
